import { FC, MouseEvent } from 'react';
import Link, { type LinkProps } from 'next/link';

import { SHARED_MEDIA_QUERIES as sharedMediaQueries } from 'src/common/constants';
import type { Photo } from 'src/common/types/api/v4/boats/search';
import Img from '../Img';
import styles from './HeroImages.module.scss';

const featureSrcSet = [
  { w: 900, query: sharedMediaQueries.xl },
  { w: 880, query: sharedMediaQueries.l },
  { w: 720, query: sharedMediaQueries.m },
];

const secondarySrcSet = [
  { w: 375, query: sharedMediaQueries.l },
  { w: 300, query: sharedMediaQueries.m },
];

export type HeroImageProps = {
  img: Photo;
  className: string;
  large: boolean;
  headline: string;
  href: LinkProps['href'];
  loading?: 'eager' | 'lazy';
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  isGalleryViewEnabled: boolean;
};

const HeroImage: FC<HeroImageProps> = ({
  img: {
    url,
    description,
  },
  className,
  large,
  headline,
  href,
  loading = 'lazy',
  onClick,
  isGalleryViewEnabled,
}) => (
  <Link
    href={isGalleryViewEnabled ? href : url}
    className={className}
    onClick={onClick}
  >
    <Img
      withPlaceholder
      src={url}
      alt={description || headline}
      className={styles.image}
      srcSetParams={large ? featureSrcSet : secondarySrcSet}
      height={310}
      width={540}
      loading={loading}
      imageParams={{
        w: 540, // TODO: full optimise widths per breakpoint
      }}
    />
  </Link>
);

export default HeroImage;
